// extracted by mini-css-extract-plugin
export default {"productGallery":"rK-z","inQuickShop":"sK-z"};